import { configureStore } from "@reduxjs/toolkit";
import gameReducer from "./game/game";
import userReducer from "./user/user";

const store = configureStore({
  reducer: {
    game: gameReducer,
    user: userReducer,
  },
});

export default store;

export const AppDispatch = store.dispatch;
